export default "__VITE_ASSET__CN6y6hqN__"